import router from './router'
import store from './store'
import * as api from './utils/api'
import { getToken } from './utils/auth'
import Layout from '@/layout'
import { setUserMsg } from "@/utils/auth"
import pageRouter from '@/utils/pageMainSlider'

let roles = store.getters.roles;
let user = store.getters.user;
export const obj = [];
if (roles.length == 0 && getToken()) {
  api.config().then(res => {
    store.dispatch('app/setRoles', res)
    let filteredItems = pageRouter.filter(item => 
      item.role.some(role => res.includes(role)) || item.role.length == 0
    );
    store.dispatch('app/setRouter', filteredItems);
    // router.addRoutes(obj)
    // console.log(router);
    
  })

}



if (!user && getToken()) {
  api.getUser().then(res => {
    setUserMsg(res)
  })
}